import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Change_password extends PureComponent {
  render() {
    return (
      <div className="row" id="change_password">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Authentication Change Password</h2>
              <p>
                The change password function allows a user to change their
                password once they've logged in and have a valid Session ID. The
                Change Password function requires the Old Password to be passed
                to the API as well as the New Password.
              </p>
              <p>
                Administrators can set minimum password length and password
                complexity rules. Like many administration settings changes to
                these settings will not affect any users who are already signed
                in. To enforce a new password policy, an administrator must log
                everyone out using the security lockdown feature in the
                application settings.
              </p>
              <p>
                Password minimum length and password complexity rules do not
                apply to administrator accounts and are not enforced when an
                administrator manually resets a user's password.
              </p>
              <p>
                Google active directory and Nexoid API accounts cannot change
                their passwords. Only normal Nexoid users have the ability to
                change their own password.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Authentication Change Password Usage</h2>
              <p>
                This example shows a user changing their password from{" "}
                <strong>goldfish</strong> to <strong>broccoli</strong>.
              </p>
              <p>Example Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/authentication/change_password
                <div>
                  <br />
                </div>
                <div>Request Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"old_password"</span>:{" "}
                  <span className="jsonY">"goldfish"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"new_password"</span>:{" "}
                  <span className="jsonY">"broccoli"</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Example Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Response Body:</div>
                <div>&#123; &#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Change_password;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Change_password.js